import { useEffect, useState } from "react";
import apiGateWay, { paymentApiGateway } from "../../serviceHandler";

const Index = () => {
  const [checkoutId, setCheckoutId] = useState(null);
  const [loaderItems, setLoaderItems] = useState([]);

  useEffect(() => {
    // Fetch the checkout ID when the component mounts
    fetchCheckoutId();
  }, []);

  // Load HyperPay script when checkoutId is ready
  useEffect(() => {
    if (checkoutId) {
      window.wpwlOptions = { style: "card", locale: "en" };
      const script = document.createElement("script");
      script.src = `https://test.oppwa.com/v1/paymentWidgets.js?checkoutId=${checkoutId}`;
      script.async = true;
      document.body.appendChild(script);

      return () => {
        document.body.removeChild(script);
      };
    }
  }, [checkoutId]);

  const handleLoader = (items, action) => {
		switch (action) {
			case "add":
				setLoaderItems([
					...loaderItems,
					...items
				]);
				break;
			case "remove":
				setLoaderItems(loaderItems.filter(item => !items.includes(item)));
				break;
			default:
				break
		}
	};

  const fetchCheckoutId = async () => {
    try {
      handleLoader(["fetchCheckoutId"], "add");
      const response = await paymentApiGateway.post(
        "/hyperpay/v1/payment/checkout",
        { 
          amount: "100.00", 
          currency: "SAR",
          paymentType: "DB",
          entityId: "8a8294174d0595bb014d05d829cb01cd",
          integrity: true,

         },
      );
      const data = await response.data;
      setCheckoutId(data.checkoutId);
      handleLoader(["fetchCheckoutId"], "remove");
    } catch (error) {
      // For testing without actual API
    //   let resultData = {
    //     "success ": true,
    //     "data": {
    //         "result": {
    //             "code": "000.200.100",
    //             "description": "successfully created checkout"
    //         },
    //         "buildNumber": "1316435f48dff01171ea928767c24b51510892b9@2025-08-21 09:50:59 +0000",
    //         "timestamp": "2025-08-21 19:22:53+0000",
    //         "ndc": "82D304396945B2BBE2182AFCED63B7A3.uat01-vm-tx01",
    //         "id": "F6A014B668AB95D875D7D25406BF45E3.uat01-vm-tx01",
    //         "integrity": "sha384-n2Ghin3ZrDwLb3ozqtN+TCvhVR+ToX28VGCHQidRk8RcbRfdbdQEtwmIJYrPSDCV"
    //     }
    // }
    //   setCheckoutId(resultData.data.id);
    console.log("Error fetching checkout ID:", error);
      handleLoader(["fetchCheckoutId"], "remove");
    };

  };

  return (
   <div className="startWrap">
      <div className="start-menu-wrapper">
      {checkoutId ? (
        <form
        action="/ezmenu/payment/result"
        className="paymentWidgets"
        data-brands="VISA MASTER MADA"
        />
      ) : (

      <span className="error-validation p-4 mb-4">Loading Payment page</span>
      )}
    </div>
    </div>
  );
};

export default Index;
